import React from "react";
import Card from "../components/card";
import Main from "../components/main";

export default function Aiml() {
  const introContent =
    "Dakshya A.I offers a variety of beginner-friendly courses, from basic Java and Python to Machine Learning. For more information, contact us at 9814103736.";



  return (
    <Main>
      {/* Intro Card */}
      <Card activeContent="IT Training For Beginners In Pokhara" content={introContent} />


    </Main>
  );
}
